// ReportActions.js
// Component for Report Actions

// Imports
import React from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup, Tooltip, Position, Button } from '@blueprintjs/core';

// Component Class
// Shows a list of buttons for processing a report
class ReportActions extends React.Component {
  // Opens the report
  open = () => {
    var report = this.props.getReport();
    if (report) report.open();
  }
  
  // Prints the report
  print = () => {
    var report = this.props.getReport();
    if (report) report.print();
  }
  
  // Saves the report
  save = () => {
    var name = this.props.getFilename();
    var report = this.props.getReport();
    if (report) report.download(name);
  }

  // Renders Component
  render() {
    return (
      <center>
        <ButtonGroup>
          <Tooltip content="Abrir" position={Position.BOTTOM} disabled={this.props.disabled}>
            <Button icon="document-open" onClick={this.open} disabled={this.props.disabled} />
          </Tooltip>
          <Tooltip content="Imprimir" position={Position.BOTTOM} disabled={this.props.disabled}>
            <Button icon="print" onClick={this.print} disabled={this.props.disabled} />
          </Tooltip>
          <Tooltip content="Salvar" position={Position.BOTTOM} disabled={this.props.disabled}>
            <Button icon="floppy-disk" onClick={this.save} disabled={this.props.disabled} />
          </Tooltip>
        </ButtonGroup>
      </center>
    );
  }
}

// Required Properties
ReportActions.propTypes = {
  disabled: PropTypes.bool,
  getReport: PropTypes.func.isRequired,
  getFilename: PropTypes.func.isRequired,
}

// Exports
export default ReportActions;


// WEBPACK FOOTER //
// ./src/components/ReportView/ReportActions.js